module.exports = __webpack_public_path__ + "static/media/logo.ff600277.svg";